export const getDataTokenName = dataTokenValue => {
  return (dataTokenValue === null || dataTokenValue === void 0 ? void 0 : dataTokenValue.split('.')[0]) || '';
};
export const getDataTokenPath = dataTokenValue => {
  return (dataTokenValue === null || dataTokenValue === void 0 ? void 0 : dataTokenValue.split('.').slice(1).join('.')) || '';
};
export const setDataTokensOnFields = (fields, dataTokenPaths, parentFieldKeyPath = '') => {
  return fields.map(field => {
    const fieldName = field.name.replace('hs_', '');
    const fieldKeyPath = parentFieldKeyPath ? `${parentFieldKeyPath}.${fieldName}` : fieldName;
    if (dataTokenPaths[fieldKeyPath]) {
      field.dataTokenValue = dataTokenPaths[fieldKeyPath];
    }
    if (field.children) {
      field.children = setDataTokensOnFields(field.children, dataTokenPaths, fieldKeyPath);
    }
    return field;
  });
};